import styled from "styled-components";
import {
  ContentFormatter,
  Flex,
  Icon,
  Accordion,
  Anchor,
  Tile,
} from "@ebscois/react-component-library";

export const TooltipWrapper = styled(ContentFormatter)`
  font-size: 0.75rem;
  ${({ theme }) => `
    width: 11rem;
    @media (min-width: ${theme.breakpoints.sm}) {
      width: 15rem;
    }
    @media (min-width: ${theme.breakpoints.md}) {
      width: 21rem;
    }
  `}
`;

export const IconWrapper = styled(Icon)`
  vertical-align: middle;
`;

export const StyledFullTextLink = styled.span.attrs({
  role: "button",
  tabIndex: 0,
  kind: "anchor",
})`
  border: 0;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  background: transparent;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.anchor};

  :hover {
    text-decoration: underline;
  }
`;

export const AccordionHeaderWrapper = styled(Flex)`
  text-transform: none;
  > :not(:first-child) {
    margin-left: 0.5rem;
  }
`;

export const StyledAccordion = styled(Accordion)`
  @media print {
    div > svg:last-child {
      transform: rotate(180deg);
    }
    div:last-child {
      height: auto !important;
      visibility: visible !important;
    }
  }
`;

export const StyledAnchor = styled(Anchor)`
  display: inline;
`;

export const StyledDialogDiv = styled.div`
  margin: ${({ theme }) => theme.space.md};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledDetailsAccordion = styled(Accordion)`
  font-weight: normal;
  margin-top: ${({ theme }) => theme.space.xs};

  && h3 span {
    font-size: ${({ theme }) => theme.font.size.sm};
  }
  @media print {
    [data-element="accordion-content-tray"] {
      height: auto;
      visibility: visible;
    }
  }
`;

export const SeparateLineUfoDiv = styled.div``;

export const InlineUfoDiv = styled.div`
  display: flex;
  vertical-align: top;
  margin-right: 0.5rem;
`;

export const StyledTableForPrint = styled.div`
  display: none;

  @media print {
    display: block;
  }
`;

export const StyledPedagogyTile = styled(Tile)`
  margin: 1rem 0 1rem -1rem;
`;
